import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';
import { Action } from '@swf/core/types/Wizard';

import SignupOffer from '../../Signup/components/SignupOffer/SignupOffer';
import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFDOB from '../components/RMFDOB/RMFDOB';
import RMFDepositLimit from '../components/RMFDepositLimit/RMFDepositLimit';
import RMFDepositLimitsIntroduction from '../components/RMFDepositLimitsIntroduction/RMFDepositLimitsIntroduction';
import RMFGender from '../components/RMFGender/RMFGender';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../components/RMFPhone/RMFPhone';

import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfUSMIFlow = (): FlowConfig => {
  const forkSGScreen = new Fork(
    Guard.showSGScreen,
    [RMFDepositLimitsIntroduction],
    RMFDepositLimit
  );

  const invokeRmfDobUpdate = new Invoke(Service.RmfDobUpdate, RMFAddress, RMFDOB);
  const forkDobCheck = new Fork(
    Guard.RmfDobEnabled,
    [RMFDOB, invokeRmfDobUpdate, RMFAddress],
    [RMFAddress]
  );
  const invokeSignupDob = new Invoke(Service.SignupDobFetch, forkDobCheck);

  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };

  const forkSignupDepositCheckDone = new Fork(
    Guard.SignupDepositEnabled,
    [{ name: 'rmfExit', entry: Action.GoNext }],
    [SignupOffer]
  );

  const forkJumpToFeature = new Fork(
    Guard.DoesJumpToFeatureStep,
    [new Invoke(Service.SetJumpCreator, jumpToFeatureStep)],
    [forkSignupDepositCheckDone]
  );

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlag,
    forkJumpToFeature,
    forkSGScreen
  );

  const invokeDepositLimitSave = new Invoke(
    Service.RmfDepositLimitSave,
    invokeEnableRealMoneyFlag,
    RMFDepositLimit
  );
  const invokeLegalNameSave = new Invoke(Service.RmfLegalNameSave, RMFGender, RMFLegalName);
  const invokeGenderSave = new Invoke(Service.RmfGenderSave, invokeSignupDob, RMFGender);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, forkSGScreen, RMFAddress);

  const forkDepositLimits = new Fork(Guard.LimitsSelected, invokeEnableRealMoneyFlag, [
    RMFDepositLimit,
    invokeDepositLimitSave
  ]);

  const invokeRMFPhoneSave = new Invoke(Service.RmfMobilePhoneSave, RMFLegalName, RMFPhone);

  return [
    RMFPhone,
    invokeRMFPhoneSave,
    RMFLegalName,
    invokeLegalNameSave,
    RMFGender,
    invokeGenderSave,
    invokeSignupDob,
    forkDobCheck,
    invokeAddressSave,
    forkSGScreen,
    forkDepositLimits,
    forkJumpToFeature,
    jumpToFeatureStep
  ];
};

export default useRmfUSMIFlow;
